import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
function BannerCampaignPayment() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [allCategory, setAllCategory] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [amount, setAmount] = useState("");
  const [city, setCity] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [catId, setCatId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);
  const [banner, setBanner] = useState(false);
  const [campaign, setCampaign] = useState(false);
  const [cityNameArray, setCityNameArray] = useState([]);
  const [addedCityNameArray, setAddedCityNameArray] = useState([]);
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food-admin/get-all-bc-payment`)
      .then((res) => {
        console.log("categoiryeueye", res.data.bannerPaymentDetails);
        setSpinner(false);
        setAllCategory(res.data.bannerPaymentDetails);
        setSearchData(res.data.bannerPaymentDetails);
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Category.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllCategory(filteredData);
  }
 
  function addCategory() {
    let catFields = {
      Amount: amount,
      Banner: banner,
      Campaign: campaign,
      NoOfDay: 1,
      City: cityNameArray,
    };
    let cat = {
      data: JSON.stringify(catFields),
    };
    axios
      .post(`${Baseurl.baseurl4}/go-food-admin/create-bc-payment`, cat)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Created", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateCategory() {
    let catFields = {
        banner:banner,
        campaign:campaign,
        amount:amount,
        noOfDay:1
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/update-bc-payment/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
 
  function deleteCategory() {
    axios
      .delete(
        `${Baseurl.baseurl4}/go-food-admin/delete-bc-payment/${catId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    setShow(true);
    setCatId(val._id);
    setUpdateStatus(true);
    setAmount(val.Amount);
    setAddedCityNameArray(val.City);
    setBanner(val.Banner);
    setCampaign(val.Campaign);
  }
  function addCityName() {
    setCityNameArray(
      (oldArray) => oldArray.concat(city),
      () => {}
    );
    setCity("");
  }
  function removeCity(val) {
    let cityField = {
      city: val,
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/remove-city-bc-payment/${catId}`,
        cityField
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Removed", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }

  function updateCityNames() {
    let cityField = {
      city: cityNameArray,
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/add-city-bc-payment/${catId}`,
        cityField
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          setCityNameArray([]);
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Test</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Category ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteCategory();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
           
            <div className="row ">
              <div className="col-sm-2 mt-2">
                <label>
                  Banner <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <Switch
                  onColor="#135334"
                  onChange={() => {
                    setBanner(!banner);
                  }}
                  checked={banner}
                />
              </div>
              <div className="col-sm-2 mt-2">
                <label>
                  Campaign <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <Switch
                  onColor="#135334"
                  onChange={() => {
                    setCampaign(!campaign);
                  }}
                  checked={campaign}
                />
              </div>
            </div>
            <div className="row mt-4">
            <div className="col-sm-2 mt-2">
                <label>
                  Amount <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={amount}
                  type="number"
                  className="form-control"
                  placeholder="enter amount"
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-6">
                <div className="row">
                  <div className="col-sm-3 mt-2">
                    <label>
                      City <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-6">
                    <input
                      value={city}
                      type="text"
                      className="form-control"
                      placeholder="enter city Name"
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                  </div>
                  <div
                    onClick={() => {
                      addCityName();
                    }}
                    className="btn btn-primary"
                  >
                    add
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4"></div>
                  <div className="col-sm-6 text-center">
                    <thead>
                      <th>City Name</th>
                    </thead>
                  </div>
                </div>

                {addedCityNameArray.length !== 0 && updateStatus && (
                  <div className="row mt-2">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-6">
                      <table className="text-center">
                        <tbody>
                          {addedCityNameArray.map((val) => {
                            return (
                              <tr>
                                <td>
                                  <div className="row">
                                    <div className="col-sm-8 mt-2">{val}</div>
                                    <div className="col-sm-2">
                                      <Link
                                        onClick={() => {
                                          removeCity(val);
                                        }}
                                        href="#"
                                        className="btn btn-danger shadow btn-xs sharp mt-1"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {cityNameArray.length !== 0 && (
                  <div className="row mt-2">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-6">
                      <table className="text-center">
                        <tbody>
                          {cityNameArray.map((val) => {
                            return (
                              <tr>
                                <td>{val}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {updateStatus && cityNameArray.length !== 0 && (
                  <div className="text-center mt-4">
                    <button
                      onClick={() => {
                        updateCityNames();
                      }}
                      className="btn btn-primary text-center mt-3"
                    >
                      Update
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateCategory();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addCategory();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              setShow(true);
              setUpdateStatus(false);
              setCity("");
              setAmount("");
              setBanner(false);
              setCampaign(false);
              setCityNameArray([])
            }}
            className="btn btn-primary"
          >
            Add Payment
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Amount</strong>
                    </th>
                    <th>
                      <strong>No Of Days</strong>
                    </th>
                    <th>
                      <strong>City</strong>
                    </th>
                    <th>
                      <strong>Banner</strong>
                    </th>
                    <th>
                      <strong>Campaign</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCategory &&
                    allCategory.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>{val.Amount}</td>
                        <td>{val.NoOfDay}</td>

                        <td>
                          {val.City &&
                            val.City.map((item) => {
                              return <div>{item}</div>;
                            })}
                        </td>
                        <td>{val.Banner ? "Included" : "Excluded"}</td>
                        <td>{val.Campaign ? "Included" : "Excluded"}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCategory && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCategory
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default BannerCampaignPayment;
